import type { Recipe } from '../types'

/** Recipes for the Bake flow: step-by-step with ingredients, in-app build + in-person option */
export const BAKERY_RECIPES: Recipe[] = [
  {
    id: 'chocolate-chip-cookies',
    name: 'Chocolate Chip Cookies',
    description: 'Yummy cookies you can make together',
    emoji: '🍪',
    steps: [
      { id: 's1', order: 1, label: 'Get a big bowl', instruction: 'Find a big mixing bowl and put it on the table.', emoji: '🥣', stage: 'bowl' },
      { id: 's2', order: 2, label: 'Add flour', instruction: 'Ask a grown-up to help you pour 2 cups of flour into the bowl.', emoji: '🌾', stage: 'bowl' },
      { id: 's3', order: 3, label: 'Add sugar', instruction: 'Add 1 cup of sugar. Mix it with the flour!', emoji: '🧂', stage: 'bowl' },
      { id: 's4', order: 4, label: 'Add butter & egg', instruction: 'Add soft butter and 1 egg. A grown-up can crack the egg.', emoji: '🧈', stage: 'bowl' },
      { id: 's5', order: 5, label: 'Add chocolate chips', instruction: 'Pour in lots of chocolate chips. The more the better!', emoji: '🍫', stage: 'bowl' },
      { id: 's6', order: 6, label: 'Mix it up', instruction: 'Stir everything together until it looks like cookie dough.', emoji: '🥄', stage: 'mix' },
      { id: 's7', order: 7, label: 'Make little balls', instruction: 'Roll the dough into little balls and put them on a tray.', emoji: '⭕', stage: 'oven' },
      { id: 's8', order: 8, label: 'Bake', instruction: 'A grown-up puts the tray in the oven. Wait for them to get golden!', emoji: '🔥', stage: 'oven' },
      { id: 's9', order: 9, label: "You did it!", instruction: 'Let them cool a little, then enjoy your cookies!', emoji: '🍪', stage: 'done' },
    ],
  },
  {
    id: 'cupcakes',
    name: 'Cupcakes',
    description: 'Make fluffy cupcakes and decorate them',
    emoji: '🧁',
    steps: [
      { id: 'c1', order: 1, label: 'Get your bowl', instruction: 'Find a big mixing bowl.', emoji: '🥣', stage: 'bowl' },
      { id: 'c2', order: 2, label: 'Add flour & sugar', instruction: 'Add 2 cups flour and 1 cup sugar to the bowl.', emoji: '🌾', stage: 'bowl' },
      { id: 'c3', order: 3, label: 'Add milk & butter', instruction: 'Add milk and soft butter. A grown-up can help measure.', emoji: '🥛', stage: 'bowl' },
      { id: 'c4', order: 4, label: 'Crack the egg', instruction: 'Add 2 eggs. A grown-up can crack them!', emoji: '🥚', stage: 'bowl' },
      { id: 'c5', order: 5, label: 'Mix the batter', instruction: 'Stir everything until it’s smooth. No lumps!', emoji: '🥄', stage: 'mix' },
      { id: 'c6', order: 6, label: 'Pour into cups', instruction: 'Put paper cups in a tray. Pour the batter into each cup.', emoji: '🧁', stage: 'oven' },
      { id: 'c7', order: 7, label: 'Bake', instruction: 'A grown-up puts the tray in the oven. Wait until they’re fluffy!', emoji: '🔥', stage: 'oven' },
      { id: 'c8', order: 8, label: 'Decorate', instruction: 'When they’re cool, add frosting and sprinkles!', emoji: '🌈', stage: 'decorate' },
      { id: 'c9', order: 9, label: 'All done!', instruction: 'You made cupcakes! Yum!', emoji: '🧁', stage: 'done' },
    ],
  },
  {
    id: 'banana-bread',
    name: 'Banana Bread',
    description: 'Sweet and cozy bread to share',
    emoji: '🍞',
    steps: [
      { id: 'b1', order: 1, label: 'Mash the bananas', instruction: 'Peel 3 ripe bananas and mash them in a bowl with a fork.', emoji: '🍌', stage: 'bowl' },
      { id: 'b2', order: 2, label: 'Add sugar & butter', instruction: 'Add sugar and melted butter. Mix it together!', emoji: '🧈', stage: 'bowl' },
      { id: 'b3', order: 3, label: 'Add eggs', instruction: 'Crack 2 eggs into the bowl. A grown-up can help.', emoji: '🥚', stage: 'bowl' },
      { id: 'b4', order: 4, label: 'Add flour', instruction: 'Add flour and a little baking soda. Stir gently.', emoji: '🌾', stage: 'bowl' },
      { id: 'b5', order: 5, label: 'Mix it', instruction: 'Stir until everything is mixed. It might be lumpy – that’s OK!', emoji: '🥄', stage: 'mix' },
      { id: 'b6', order: 6, label: 'Pour in pan', instruction: 'Pour the batter into a loaf pan. A grown-up can grease the pan first.', emoji: '🍞', stage: 'oven' },
      { id: 'b7', order: 7, label: 'Bake', instruction: 'A grown-up puts it in the oven. It bakes for a long time – be patient!', emoji: '🔥', stage: 'oven' },
      { id: 'b8', order: 8, label: 'Done!', instruction: 'Let it cool, then slice and enjoy your banana bread!', emoji: '🍞', stage: 'done' },
    ],
  },
]
